var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileWish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.428 8.804l-5.9 5.9a.722.722 0 0 1-1.027 0L3.6 8.776a4.077 4.077 0 0 1 0-5.701 4.058 4.058 0 0 1 5.701 0 .95.95 0 0 0 1.35 0 4.058 4.058 0 0 1 5.701 0 4.077 4.077 0 0 1 .076 5.701zm1.34-7.089a5.977 5.977 0 0 0-7.754-.608 5.958 5.958 0 0 0-7.754 9.008l5.901 5.91a2.642 2.642 0 0 0 3.706 0l5.901-5.91a5.958 5.958 0 0 0 0-8.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWish);
export default __webpack_public_path__ + "static/media/profile_wish.45bd5fa2535dbc793b424fa907cc3461.svg";
export { ForwardRef as ReactComponent };